import { Fragment, useState } from "react";
import {
  Grid,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  IconButton,
  Tooltip,
  MenuItem,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { InfoOutlined } from "@mui/icons-material";

import ActionButtons from "./ActionButtons";
import { colors } from "../../css components/Style";
import { useAxios, useComponent } from "../../../hooks";
import {
  PrimaryButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import {
  Autocomplete,
  TextField,
  ComponentHeader,
  AutocompleteMultiSelect,
} from "../../../components";
import GovernanceDialog from "./governance component/GovernanceStatus";

export default function FormOne({
  setEditState,
  formikProps,
  brands,
  editState,
  changeData,
  setChangeData,
  fields,
  additionalFields,
  PlatformTenantList,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const { alert } = useComponent();

  const [loading, setLoading] = useState(false);
  const [dialogState, setDialogState] = useState({ state: false });

  const [showFull, setShowFull] = useState(false);
  const [wasPasted, setWasPasted] = useState(false);

  const handlePaste = () => setWasPasted(true);
  const textValue = formikProps.values.requestHeaders || "";
  const shouldShowViewMore = textValue.length > 200 && !wasPasted;

  function handleConnection() {
    setLoading(true);
    if (formikProps.values.onboardingType === "NODE") {
      axios({
        url: "/user/testConnectionDetails",
        method: "POST",
        data: {
          connection_url: formikProps.values.connectionUrl,
          port: formikProps.values.port,
          token: formikProps.values.token,
        },
        disableRedirect: true,
      }).then((res) => {
        if (res.status) {
          formikProps.setValues((prev) => ({
            ...prev,
            connection:
              res.data[0].connection_establishment === "success" ? true : false,
            fieldNames: res.data[1].column_names,
          }));
          dispatch(
            alert.success(res.data[0]?.connection_establishment || "Success")
          );
        } else {
          dispatch(alert.error(res.message));
        }
        setLoading(false);
      });
    }

    if (formikProps.values.onboardingType === "API") {
      axios({
        url: "/user/extractCohortPaths/" + formikProps.values.brandID,
        disableRedirect: true,
      }).then((res) => {
        if (res.status) {
          formikProps.setValues((prev) => ({
            ...prev,
            connection: true,
            fieldNames: res.data.map((item) => item).join(", "),
          }));
          dispatch(
            alert.success(res.data[0]?.connection_establishment || "Success")
          );
        } else {
          dispatch(alert.error(res.message));
        }
        setLoading(false);
      });
    }
  }

  return (
    <Fragment>
      <Grid size={12}>
        <ComponentHeader
          title={"Brand Details"}
          buttons={[
            <ActionButtons
              formikProps={formikProps}
              editState={editState}
              setEditState={setEditState}
              changeData={changeData}
              setChangeData={setChangeData}
            />,
            <PrimaryLoadingButton
              loading={loading}
              variant="contained"
              onClick={handleConnection}
              disabled={
                !formikProps.values.connectionUrl && !formikProps.values.port
              }
            >
              Test Connection
            </PrimaryLoadingButton>,
            formikProps.values.onboardingType === "NODE" &&
              formikProps.values.connectionID && (
                <PrimaryButton
                  variant="contained"
                  onClick={() => {
                    setDialogState({
                      state: true,
                      data: formikProps.values,
                    });
                  }}
                  disabled={
                    !formikProps.values.connectionUrl &&
                    !formikProps.values.port
                  }
                >
                  Governance Status
                </PrimaryButton>
              ),
          ]}
        />
      </Grid>

      <Grid size={4}>
        {!!formikProps.values.connectionID ? (
          <TextField
            label="Brand Name"
            name="brandName"
            formikProps={formikProps}
            disabled={!!formikProps.values.connectionID}
          />
        ) : (
          <Autocomplete
            label="Brand Name"
            name="brandID"
            forcePopupIcon={!editState ? false : true}
            placeholder="Select Brand Name"
            defaults={{
              primaryKey: "brand_id",
              displayLabel: "brand_name",
            }}
            options={brands}
            disabled={!!formikProps.values.connectionID}
            onChange={(_, value, type) => handleChangeBrand(value, type)}
            formikProps={formikProps}
          />
        )}

        {formikProps.values.onboardingType === "NODE" && (
          <FormControlLabel
            control={
              <Checkbox
                disabled={!editState}
                onChange={(e) => {
                  formikProps.setValues((prev) => ({
                    ...prev,
                    csvUpload: e.target.checked,
                  }));
                }}
                checked={formikProps.values.csvUpload}
                sx={{
                  color: colors.purple,
                  "&.Mui-checked": {
                    color: colors.purple,
                  },
                }}
              />
            }
            label="Onboarding with CSV"
          />
        )}
      </Grid>

      <Grid size={4}>
        <AutocompleteMultiSelect
          required
          label={"Select Platform Tenant"}
          name={"platforms"}
          defaults={{
            primaryKey: "platform_id",
            displayLabel: "platform_name",
          }}
          formikProps={formikProps}
          options={PlatformTenantList}
          disabled={!editState}
          forcePopupIcon={!editState ? false : true}
          placeholder="Select Platform Tenant"
          onChange={(_, arr, reason, option) => {
            handleChange(arr, option, reason, "platforms", "platform_name");
          }}
        />
      </Grid>

      <Grid size={4}>
        <TextField
          select
          required
          name="onboardingType"
          placeholder="Onboarding Type"
          label="Onboarding Type"
          disabled={!editState}
          formikProps={formikProps}
        >
          <MenuItem value="NODE">Node</MenuItem>
          <MenuItem value="API">API</MenuItem>
        </TextField>
      </Grid>

      <Grid size={4}>
        <TextField
          select
          required
          name="status"
          placeholder="Status"
          label="Status"
          disabled={!editState}
          formikProps={formikProps}
          onChange={(e) => {
            formikProps.setValues((prev) => ({
              ...prev,
              status: e.target.value,
            }));
            setChangeData(true);
          }}
        >
          <MenuItem value="ACTIVE">Active</MenuItem>
          <MenuItem value="INACTIVE">In Active</MenuItem>
        </TextField>
      </Grid>

      {formikProps.values.onboardingType === "NODE" &&
        !formikProps.values.csvUpload && (
          <Fragment>
            <Grid size={4}>
              <TextField
                name="connectionUrl"
                placeholder="IP/Domain"
                label="IP/Domain"
                required={formikProps.values.onboardingType === "NODE"}
                disabled={!editState}
                formikProps={formikProps}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position={"end"}>
                      <Tooltip title="Provide either domain or ip:port">
                        <IconButton style={{ padding: 0 }}>
                          <InfoOutlined />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid size={4}>
              <TextField
                multiline
                required={formikProps.values.onboardingType === "NODE"}
                name="token"
                placeholder="Token"
                label="Token"
                disabled={!editState}
                formikProps={formikProps}
              />
            </Grid>
          </Fragment>
        )}

      {formikProps.values.onboardingType === "API" && (
        <Fragment>
          <Grid size={6}>
            <TextField
              multiline
              required={formikProps.values.onboardingType === "API"}
              name="apiUrl"
              placeholder="API URL"
              label="API URL"
              disabled={!editState}
              formikProps={formikProps}
            />
          </Grid>

          <Grid size={6}>
            <Box position="relative">
              <TextField
                multiline
                name="requestHeaders"
                placeholder="Request Sample"
                label="Request Sample"
                disabled={!editState}
                formikProps={formikProps}
                required={formikProps.values.onboardingType === "API"}
                value={
                  showFull
                    ? formikProps.values.requestHeaders
                    : formikProps.values.requestHeaders?.slice(0, 200)
                }
                onPaste={handlePaste}
              />

              {shouldShowViewMore && (
                <Button
                  onClick={() => setShowFull((prev) => !prev)}
                  variant="text"
                  sx={{
                    position: "absolute",
                    bottom: 8,
                    right: 8,
                    textTransform: "none",
                    fontSize: 13,
                  }}
                >
                  {showFull ? "View Less" : "View More"}
                </Button>
              )}
            </Box>
          </Grid>

          <Grid size={6}>
            <TextField
              multiline
              name="requestBody"
              placeholder="Request Body"
              label="Request Body"
              disabled={!editState}
              formikProps={formikProps}
              required={formikProps.values.onboardingType === "API"}
            />
          </Grid>
        </Fragment>
      )}

      {formikProps.values.onboardingType === "NODE" && (
        <Fragment>
          <Grid size={12}>
            <Typography variant="h6">Prime Identifier</Typography>
          </Grid>

          <Grid size={3}>
            <TextField
              required
              name="mobile"
              placeholder="Mobile"
              label="Mobile"
              disabled={!editState}
              formikProps={formikProps}
            />
          </Grid>

          <Grid size={12}>
            <Typography variant="h6">Other Identifier</Typography>
          </Grid>

          <Grid size={3}>
            <TextField
              name="email"
              placeholder="Email"
              label="Email"
              disabled={!editState}
              formikProps={formikProps}
            />
          </Grid>

          <Grid size={3}>
            <TextField
              name="gaid"
              placeholder="GAID"
              label="GAID"
              disabled={!editState}
              formikProps={formikProps}
            />
          </Grid>
        </Fragment>
      )}

      {formikProps.values.connectionID && (
        <Fragment>
          <Grid size={12}>
            <Typography variant="h6">Additional Fields</Typography>
          </Grid>

          <Grid size={6}>
            <AutocompleteMultiSelect
              label="Additional Fields"
              name="additionalFields"
              forcePopupIcon={!editState ? false : true}
              placeholder="Select Additional Fields"
              defaults={{
                primaryKey: "field_name",
                displayLabel: "field_name",
              }}
              options={additionalFields}
              disabled={!editState}
              onChange={(_, arr, reason, detail) =>
                handleAddFields(arr, detail, reason)
              }
              formikProps={formikProps}
            />
          </Grid>
        </Fragment>
      )}

      <GovernanceDialog
        dialogState={dialogState}
        setDialogState={setDialogState}
      />
    </Fragment>
  );

  function handleChange(arr, { option }, reason, name, displayName) {
    formikProps.setValues((prevVal) => ({
      ...prevVal,
      [name]: setValuesOfDropDown(prevVal[name]),
    }));

    function setValuesOfDropDown(val) {
      let values = !Array.isArray(val) ? [] : [...val];

      const index = values.indexOf(option["platform_id"]);
      if (index > -1) {
        values.splice(index, 1);
      } else {
        values.push(option["platform_id"]);
      }

      return values;
    }
  }

  // Helper functions
  function handleAddFields(arr, { option }, reason) {
    let values = [...formikProps.values.additionalFields] || [];

    if (reason === "removeOption") {
      values.splice(1, values.indexOf(option.field_name));
    }

    if (reason === "selectOption") {
      values.push(option.field_name);
    }
    formikProps.setValues((prev) => ({
      ...prev,
      additionalFields: values,
    }));
  }

  function handleChangeBrand(value, type) {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        brandID: value.brand_id,
      }));
    } else {
      value = {
        brand_id: "",
        brand_name: "",
      };

      formikProps.setValues((prevVal) => ({
        ...prevVal,
        brandID: value.brandID,
      }));
    }
  }
}
